import { SimpleChanges } from '@angular/core';

export function hasChange<T>(changes: SimpleChanges, inputName: keyof T) {
  if (!changes) {
    return false;
  }

  const { [inputName]: input } = changes;

  return Boolean(input) && input.currentValue !== input.previousValue;
}
